
export interface LogEntry {
  level: 'INFO' | 'WARN' | 'ERROR';
  message: string;
  data?: Record<string, unknown>;
  timestamp: string;
}

export const Logger = {
  log: (level: 'INFO' | 'WARN' | 'ERROR', message: string, data?: Record<string, unknown>) => {
    if (message === 'Canceled' && (data?.stack as string)?.includes('Canceled')) return;
    const entry: LogEntry = { level, message, data, timestamp: new Date().toISOString() };
    if (level === 'ERROR') {
      console.error('[Logger Service]', entry);
    } else {
      console.log('[Logger Service]', entry);
    }
  },
  info: (message: string, data?: Record<string, unknown>) => Logger.log('INFO', message, data),
  warn: (message: string, data?: Record<string, unknown>) => Logger.log('WARN', message, data),
  error: (error: unknown, context?: Record<string, unknown>) => {
    const message = error instanceof Error ? error.message : String(error);
    if (message === 'Canceled') return;
    const data = { stack: error instanceof Error ? error.stack : undefined, ...context };
    Logger.log('ERROR', message, data);
  }
};
